"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageHeader = void 0;
var tslib_1 = require("tslib");
var asg_1 = require("@alinta-digital/asg");
var react_1 = tslib_1.__importStar(require("react"));
var PageHeader = function (_a) {
    var initialLoad = _a.initialLoad;
    var responsiveSize = (0, react_1.useContext)(asg_1.ResponsiveContext);
    return (react_1.default.createElement(react_1.default.Fragment, null, initialLoad ? (react_1.default.createElement(asg_1.Box, { width: "100%", maxWidth: "1088px", margin: {
            horizontal: 'auto',
            top: responsiveSize === 'xs' ? '40px' : responsiveSize === 'sm' || responsiveSize === 'md' ? '65px' : '99px',
        }, "data-testid": "bubbleTopSkeleton" })) : (react_1.default.createElement(asg_1.BubbleTop, null))));
};
exports.PageHeader = PageHeader;
//# sourceMappingURL=PageHeader.js.map